// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod`.

import { addSlashToOriginPath } from '@utils/EnvironmentRetriver';
import { BASE_PREFERENCE_PATH, BASE_SERVICE_PATH } from '@utils/UrlUtils';

export const environment = {
  production: false,
  baseUrl: `${addSlashToOriginPath(window.location.origin)}${BASE_SERVICE_PATH}/api`,
  localUrl: process.env.REACT_APP_LOCAL_URL,
};

export const preferencesEnvironment = {
  production: false,
  baseUrl: `${addSlashToOriginPath(window.location.origin)}${BASE_PREFERENCE_PATH}`,
  localUrl: process.env.REACT_APP_LOCAL_URL,
};

export const shareEnvironment = {
  production: false,
  baseUrl: `${addSlashToOriginPath(window.location.origin)}api/users-api/v1`,
  localUrl: process.env.REACT_APP_LOCAL_URL,
  personalUrl: `${addSlashToOriginPath(window.location.origin)}api/persona`,
};
